import {
  IAddCustomerInTeamRoute,
  ICheckValidSaleTeam,
  IFilterTeamSale,
  IFilterTeamSaleCb,
  IGetAllById,
  IGetAllComboBox,
  IGetAllFilterTeamSales,
  IGetManagerCombobox,
  IGetSlocByPlant,
  IGetTeamSaleDetailById,
  IGetUserByPlantNotTeamSale,
  IGetValidTeamSaleById,
  IParamsCreate,
  IParamsUpdate,
  STATUS_TS,
} from 'interfaces/TeamSale/TeamSale';
import { DEFAULT_PAGE_SIZE } from 'utils/constants/constant';

export const TEAMSALE_VARIABLE = {
  getAll: (params: IFilterTeamSale) => {
    const { page, pageSize } = params;
    const currentSkip = page || 1;
    const currentTake = pageSize || DEFAULT_PAGE_SIZE;

    return {
      input: {
        ...(params.id && { id: { equals: params.id } }),
        ...(params.tteamSalesDetails && {
          tteamSalesDetails: { userId: { equals: params.tteamSalesDetails } },
        }),
        ...(params.plantId && { plantId: { equals: params.plantId } }),
        ...(params.teamTypeId && {
          teamType: { equals: params.teamTypeId },
        }),
        ...(params.statusId && { statusId: { equals: params.statusId } }),
        OR: [
          { ...(params.idOrName && { id: { contains: params.idOrName } }) },
          { ...(params.idOrName && { name: { contains: params.idOrName } }) },
        ],
      },
      ...(page && { skip: (currentSkip - 1) * currentTake }),
      ...(pageSize && { take: currentTake }),
    };
  },
  getAllFilterTeamSales: (params: IGetAllFilterTeamSales) => {
    return {
      ...(params.page && {
        skip: (params.page - 1) * (params?.pageSize ?? DEFAULT_PAGE_SIZE),
      }),
      ...(params.pageSize && { take: params.pageSize }),
      input: {
        plantId: params?.plantId ?? '5000',
        ...(params.userId && { userId: params.userId }),
        ...(params.teamSaleId && { teamSaleId: params.teamSaleId }),
        ...(params.teamTypeId && { teamTypeId: params.teamTypeId }),
        ...(params.managerId && { managerId: params.managerId }),
        ...(params.statusId && {
          statusId: params.statusId === STATUS_TS.active ? true : false,
        }),
      },
    };
  },
  getAllTeamSaleCb: (params: IFilterTeamSaleCb) => {
    const { value, pageSize, plantId, useYn, managerId, userId } = params;

    return {
      skip: 0,
      take: pageSize,
      input: {
        ...(plantId && { plantId: { equals: plantId } }),
        ...(managerId && { manageId: { equals: managerId } }),
        ...(userId && { tteamSalesDetails: { userId: { equals: userId } } }),
        ...(value && {
          OR: [
            {
              subId: {
                contains: value,
              },
            },
            {
              name: {
                contains: value,
              },
            },
          ],
        }),
        ...(useYn !== undefined && {
          useYn: {
            equals: useYn,
          },
        }),
      },
    };
  },
  create: (params: IParamsCreate) => {
    const {
      id,
      subId,
      name,
      plantId,
      salesTeamCode,
      isWork,
      teamTypeId,
      createDate,
      createId,
      endDate,
      sloc,
      teamCapacity,
      manageId,
    } = params;

    return {
      data: {
        id,
        subId,
        name,
        plantId,
        salesTeamCode,
        isWork,
        teamType: teamTypeId,
        createDate,
        createId,
        endDate,
        sloc,
        manageId,
        teamCapacity: parseFloat(teamCapacity.toString()),
        useYn: true,
      },
    };
  },
  createList: (params: IParamsCreate[]) => {
    return {
      data: params,
    };
  },
  update: (params: IParamsUpdate) => {
    const {
      id,
      name,
      plantId,
      salesTeamCode,
      teamTypeId,
      useYn,
      modifyDate,
      modifyId,
      endDate,
      sloc,
      teamCapacity,
      manageId,
    } = params;

    return {
      data: {
        id,
        name,
        plantId,
        salesTeamCode,
        teamType: teamTypeId,
        useYn,
        modifyDate,
        modifyId,
        endDate,
        sloc,
        manageId,
        teamCapacity: parseFloat(teamCapacity.toString()),
      },
    };
  },
  getTeamSaleById: (id: string | undefined) => {
    return {
      input: {
        teamSaleId: { equals: id },
        useYn: { equals: true },
      },
    };
  },
  deleteEmployeeTeamSale: (id: string, endDate: string) => {
    return {
      data: id,
      // data: {
      //   id: id,
      //   useYn: false,
      //   endDate,
      // },
    };
  },
  getEmployeeNoTS: () => {
    return {
      input: {
        activeRoute: { equals: false },
      },
    };
  },
  getCustomerByTS: (params: IGetAllById) => {
    const { page, pageSize } = params;
    const currentSkip = page || 1;
    const currentTake = pageSize || DEFAULT_PAGE_SIZE;

    return {
      ...(page && { skip: (currentSkip - 1) * currentTake }),
      ...(pageSize && { take: currentTake }),
      input: {
        teamSalesId: { equals: params.teamSalesId },
        OR: [
          {
            tcustomer: {
              cccd: {
                contains: params.tcustomer,
              },
            },
          },
          {
            tcustomer: {
              taxId: {
                contains: params.tcustomer,
              },
            },
          },
          {
            tcustomer: {
              id: {
                contains: params.tcustomer,
              },
            },
          },
          {
            tcustomer: {
              storeName: {
                contains: params.tcustomer,
              },
            },
          },
          {
            tcustomer: {
              sapCustomerId: {
                contains: params.tcustomer,
              },
            },
          },
        ],
      },
    };
  },
  deleteCustomer: (customerId: string) => {
    return {
      input: customerId,
    };
  },
  GetCustomerByTeamSaleRoute: (input: any) => {
    return {
      input,
    };
  },
  getAllComboBox: (params: IGetAllComboBox) => {
    const { page, pageSize } = params;
    const currentSkip = page || 1;
    const currentTake = pageSize || DEFAULT_PAGE_SIZE;

    return {
      ...(page && { skip: (currentSkip - 1) * currentTake }),
      ...(pageSize && { take: currentTake }),
    };
  },
  getTeamSaleDetailById: (params: IGetTeamSaleDetailById) => {
    const { page, pageSize } = params;
    const currentSkip = page || 1;
    const currentTake = pageSize || DEFAULT_PAGE_SIZE;

    return {
      ...(page && { skip: (currentSkip - 1) * currentTake }),
      ...(pageSize && { take: currentTake }),
      input: {
        teamSaleId: { equals: params.teamSaleId },
        useYn: { equals: params?.useYn ?? true },
        OR: [
          {
            user: {
              fullName: {
                contains: params.user,
              },
            },
          },
          {
            user: {
              id: {
                contains: params.user,
              },
            },
          },
        ],
      },
    };
  },
  addCustomerInTeamRoute: (params: IAddCustomerInTeamRoute) => {
    const { routeId, teamId, custId } = params;

    return {
      input: {
        routeId,
        teamId,
        custId,
      },
    };
  },
  deleteSaleTeam: (teamSaleId: string) => {
    return { input: teamSaleId };
  },
  generateTeamCodeByTypeAndPlantId: (params: {
    type: string;
    plantId: string;
  }) => {
    return {
      input: params,
    };
  },
  getUserByPlantId: (params: IGetUserByPlantNotTeamSale) => {
    const { page, pageSize } = params;
    const currentSkip = page || 1;
    const currentTake = pageSize || DEFAULT_PAGE_SIZE;
    const value = params?.searchValue ?? '';

    return {
      ...(page && { skip: (currentSkip - 1) * currentTake }),
      ...(pageSize && { take: currentTake }),
      input: {
        role: {
          equals: 'sale',
        },
        activeRoute: { equals: false },
        ...(params.plantId && { plantCode: { equals: params.plantId } }),
        OR: [
          { email: { contains: value } },
          { id: { contains: value } },
          { fullName: { contains: value } },
        ],
      },
    };
  },
  getSlocByPlantId: (params: IGetSlocByPlant) => {
    const { page, pageSize } = params;
    const currentSkip = page || 1;
    const currentTake = pageSize || DEFAULT_PAGE_SIZE;

    return {
      skip: (currentSkip - 1) * currentTake,
      take: currentTake,
      input: {
        plantId: { equals: params.plantId },
        id: { contains: params?.searchValue ?? '' },
      },
    };
  },
  getProgressByPlantId: ({
    plantId,
    teamId,
  }: {
    plantId: string;
    teamId?: string;
  }) => {
    return {
      input: {
        year: new Date().getFullYear().toString(),
        plant: plantId,
        ...(teamId && { teamId: teamId }),
      },
    };
  },
  getAllTotalSaleAmt: (params: { plantId: string; year: number }) => {
    return { input: params };
  },
  checkExistRouteOfSaleTeam: (teamSaleId: string) => {
    return {
      input: { teamSalesId: { equals: teamSaleId } },
    };
  },
  checkValidTeamSale: (params: ICheckValidSaleTeam) => {
    return {
      input: {
        id: { equals: params.id },
        useYn: { equals: true },
      },
    };
  },
  getValidTeamSaleById: ({
    isWork = true,
    teamSaleId,
  }: IGetValidTeamSaleById) => {
    return {
      input: {
        id: { equals: teamSaleId },
        useYn: { equals: isWork },
      },
    };
  },
  checkUserActiveRouteInTeam: (params: {
    teamSalesSubId: string;
    plantId: string;
  }) => {
    return {
      input: {
        teamSalesId: params.teamSalesSubId,
        plantId: params.plantId,
      },
    };
  },
  getManagersCombobox: (params: IGetManagerCombobox) => {
    return {
      take: params?.pageSize ?? 10,
      skip: 0,
      input: {
        role: {
          equals: 'qld',
        },
        plantCode: {
          equals: params.plantId,
        },
        OR: [
          {
            fullName: {
              contains: params?.searchValue ?? '',
            },
          },
          {
            email: {
              contains: params?.searchValue ?? '',
            },
          },
        ],
      },
    };
  },
};
